/*
 * @Description:
 * @Author: bingjing.wang
 * @Date: 2020-04-29 10:13:47
 * @LastEditTime: 2021-05-07 16:27:45
 * @LastEditors: Wang Bingjing
 */
import Cookies from 'js-cookie';

const KEY_USERNAME = 'taimi.operational.user.user';
const KEY_USER_ROLE = 'taimi.operational.user.role';
const KEY_USER_ID = 'taimi.operational.user.userId';
const KEY_USER_TOKEN = 'taimi.operational.user.token';
const KEY_DEPARTMENT= 'taimi.operational.user.department';
const KEY_STAFF = 'staff'

export function removeAll() {
	Cookies.remove(KEY_USER_ID);
	Cookies.remove(KEY_USERNAME);
	Cookies.remove(KEY_USER_ROLE);
	Cookies.remove(KEY_USER_TOKEN);
	Cookies.remove(KEY_DEPARTMENT);
	Cookies.remove(KEY_STAFF);
}

export function setUserId(id) {
	Cookies.set(KEY_USER_ID, id, { expires: 7 });
}

export function setUsername(username) {
	Cookies.set(KEY_USERNAME, username, { expires: 7 });
}

export function setRole(role) {
	Cookies.set(KEY_USER_ROLE, role, { expires: 7 });
}

export function setToken(token) {
	Cookies.set(KEY_USER_TOKEN, token, { expires: 7 });
}

export function setDepartment(department) {
	Cookies.set(KEY_DEPARTMENT, department, { expires: 7 });
}

export async function setStaff(staff) {
	Cookies.set(KEY_STAFF, staff, { expires: 7 });
}

export function getStaff() {
	return Cookies.get(KEY_STAFF) || '';
}

export function getDepartment() {
	return Cookies.get(KEY_DEPARTMENT) || '';
}

export function getUserId() {
	return Cookies.get(KEY_USER_ID) || '';
}

export function getUsername() {
	return Cookies.get(KEY_USERNAME) || '';
}

export function getRole() {
	return Cookies.get(KEY_USER_ROLE) || '';
}

export function getToken() {
	return Cookies.get(KEY_USER_TOKEN) || [];
}

export function isAuthenticated() {
	try {
		const token = getToken();
		const role = getRole();
		const id = getUserId();
		if (!token || !role || !id) {
			return false;
		}
		return true;
	} catch (err) {
		console.log(err);
		return false;
	}
}
